import { get } from 'aws-amplify/api';

export async function fetchData(apiName, path) {
    try {
        const { body } = await get({
            apiName: apiName,
            path: path
        }).response;

        const data = await body.json();
        return data;

    } catch (error) {
        console.error(`Error fetching data from ${apiName} at ${path}:`, error);
        throw error;
    }
};